angular.module('tf.models')

    .factory("BillingSource",[function(){

        var billingSource = function BillingSource(data) {
            this.loadData(data);
        };


        billingSource.prototype = {
            loadData: function (data) {
                angular.extend(this, data);
            },
            getBrand : function(){return this.brand;},
            getLast4Digit : function(){return this.last4;},
            getExpDate : function(){return this.exp_month + '/' + this.exp_year ;},
        };

        return billingSource;

    }])
;
